// debugger
(function ( $ ) {
    $.ld_debug = function ( text ) {
	    if ( $.ld_is_development() ) {
			console.log( text ); 
	    }  
    };
})( jQuery );

// decide environment
(function ( $ ) {
    $.ld_is_development = function ( ) {
	    if ( $('body').hasClass('env_local') ) {
			return true;
	    } else {
			return false;
	    }
    };
})( jQuery );

